<section class="breadcrumbs_common bg_img pos_relative">
  <div class="overlay-innerpage"></div>
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <div class="breadcrumbs_content">
          <h2 class="text-white">B.Sc. Hospitality Studies</h2>
          <ul class="breadcrumb">
            <li>
              <a routerLink="/">Home</a>
            </li>/
            <li class="active">
              <a href="javascript:void(0);">B.Sc. Hospitality Studies</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="computer-application ptb--100  horizontal--tab">
  <div class="container">
    <div class="row">
      <div class="col">
        <ul class="nav nav-tabs" id="myTab" role="tablist">
          <li class="nav-item" role="presentation">
            <button class="nav-link active" id="department-tab" data-bs-toggle="tab" data-bs-target="#department"
              type="button" role="tab" aria-controls="department" aria-selected="true">About Department</button>
          </li>
          <li class="nav-item" role="presentation">
            <button class="nav-link" id="eligibility-tab" data-bs-toggle="tab" data-bs-target="#eligibility"
              type="button" role="tab" aria-controls="eligibility" aria-selected="false">Eligibility Criteria</button>
          </li>
          <li class="nav-item" role="presentation">
            <button class="nav-link" id="duration-tab" data-bs-toggle="tab" data-bs-target="#duration" type="button"
              role="tab" aria-controls="duration" aria-selected="false">Duration</button>
          </li>
        </ul>
        <div class="tab-content px-3 py-3" id="myTabContent">
          <div class="tab-pane fade show active" id="department" role="tabpanel" aria-labelledby="department-tab">
            <div>
              <p>The B.Sc. – Hospitality Studies programme is made of intensive six semester curriculum which equips the
                student with the knowledge and skills essential in the hospitality industry. The courses relevant to the
                Industry of today, like Environmental Sciences, Tourism Operations, Hotel Laws etc. have been included
                in the curriculum. With this revision a Choice Based Credit System has been introduced to provide
                choices for students to select from the prescribed courses. CBCS provides a ‘Cafeteria’ approach in
                which the students can take courses of their choice and adopt an interdisciplinary approach to learning.
                This revision also introduces a shift from conventional marking system to a grading system. The
                requirement for awarding a degree is prescribed in terms of the number of credits to be completed by the
                students.</p>
            </div>
          </div>
          <div class="tab-pane fade" id="eligibility" role="tabpanel" aria-labelledby="eligibility-tab">
            <p>The minimum eligibility for the course would be HSC (Std.12th) or its equivalent, passing with the
              minimum of 50% marks in aggregate. (45% marks in case of candidates of backward class categories belonging
              to Maharashtra State). For students with non-science background a bridge course in science namely 'Basics
              of Hospitality Applied Sciences'; will be conducted in the first year of the course. The duration of the
              bridge course will be of four weeks.</p>
          </div>
          <div class="tab-pane fade" id="duration" role="tabpanel" aria-labelledby="duration-tab">
            <h4 class="yellow-color fw-bold">3-years</h4>
            <p>B.Sc Hospitality Studies is a three-year course that focuses on the Hospitality sector along with the
              Tourism industry.</p>
          </div>
        </div>

        <div class="text-center">
          <a href="https://raisoni.nopaperforms.com/rgi" target="_blank" class="cmn-button">Apply Now</a>
        </div>
      </div>
    </div>
  </div>
</section>
